import React from 'react';
import CountUp from 'react-countup';
import { getSettings } from '../../services/api';

class Achievements extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            achievements: {
                yearsExperience: "16+",
                projectsCompleted: "1100+",
                clientSatisfaction: "100%"
            }
        };
    }

    async componentDidMount() {
        try {
            const data = await getSettings();
            if (data && data.achievements) {
                const ach = data.achievements;
                this.setState({
                    achievements: {
                        yearsExperience: ach.yearsExperience || "16+",
                        projectsCompleted: ach.projectsCompleted || "1100+",
                        clientSatisfaction: ach.clientSatisfaction || "100%"
                    }
                });
            }
        } catch (e) {
            console.warn('[Achievements] API fetch fallback to default props.');
        }
    }

    parseNum = (val) => {
        if (!val) return 0;
        if (typeof val === 'number') return val;
        const str = String(val);
        const num = parseInt(str.replace(/[^0-9]/g, ''), 10);
        return isNaN(num) ? 0 : num;
    };

    render() {
        const { yearsExperience, projectsCompleted, clientSatisfaction } = this.state.achievements;

        return (
            <>
                <div className="section-full mobile-page-padding p-t70 p-b40" style={{ backgroundColor: '#111111', borderTop: '1px solid #222222', borderBottom: '1px solid #222222' }}>
                    <div className="container">
                        <div className="row counter-row justify-content-center">
                            {/* YEARS EXPERIENCE */}
                            <div className="col-lg-4 col-md-4 col-sm-12 m-b30 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.1s">
                                <div className="counter-box text-center p-a30" style={{ borderRadius: '12px', backgroundColor: '#181818', border: '1px solid rgba(240, 58, 2, 0.25)', boxShadow: '0 6px 20px rgba(0,0,0,0.3)' }}>
                                    <h2 className="m-b10" style={{ color: '#f03a02', fontSize: '46px', fontWeight: '800' }}>
                                        <CountUp end={this.parseNum(yearsExperience)} duration={3} />+
                                    </h2>
                                    <h6 className="m-b0" style={{ color: '#ffffff', textTransform: 'uppercase', letterSpacing: '1px', fontSize: '13.5px', fontWeight: '700' }}>Years Experience</h6>
                                </div>
                            </div>

                            {/* PROJECTS COMPLETED */}
                            <div className="col-lg-4 col-md-4 col-sm-12 m-b30 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.25s">
                                <div className="counter-box text-center p-a30" style={{ borderRadius: '12px', backgroundColor: '#181818', border: '1px solid rgba(240, 58, 2, 0.25)', boxShadow: '0 6px 20px rgba(0,0,0,0.3)' }}>
                                    <h2 className="m-b10" style={{ color: '#f03a02', fontSize: '46px', fontWeight: '800' }}>
                                        <CountUp end={this.parseNum(projectsCompleted)} duration={3} />+
                                    </h2>
                                    <h6 className="m-b0" style={{ color: '#ffffff', textTransform: 'uppercase', letterSpacing: '1px', fontSize: '13.5px', fontWeight: '700' }}>Projects Completed</h6>
                                </div>
                            </div>

                            {/* CLIENT SATISFACTION */}
                            <div className="col-lg-4 col-md-4 col-sm-12 m-b30 wow fadeInUp" data-wow-duration="1s" data-wow-delay="0.4s">
                                <div className="counter-box text-center p-a30" style={{ borderRadius: '12px', backgroundColor: '#181818', border: '1px solid rgba(240, 58, 2, 0.25)', boxShadow: '0 6px 20px rgba(0,0,0,0.3)' }}>
                                    <h2 className="m-b10" style={{ color: '#f03a02', fontSize: '46px', fontWeight: '800' }}>
                                        <CountUp end={this.parseNum(clientSatisfaction)} duration={3} />%
                                    </h2>
                                    <h6 className="m-b0" style={{ color: '#ffffff', textTransform: 'uppercase', letterSpacing: '1px', fontSize: '13.5px', fontWeight: '700' }}>Client Satisfaction</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Achievements;
